<template>
  <div id="App" :class="isProductView ? 'isProductView' : ''">
    <div class="head">
      <HeadPhone />
    </div>
    <div class="main">
      <router-view />
      <div class="footer" :class="isProductView ? 'isProductView' : ''">
        上海执行派体育发展有限公司 PowerFun
        <span
          @click="toIntegrated"
          :class="isProductView ? 'isProductView' : ''"
          >沪ICP备16001908号-4A</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import HeadPhone from "./components/HeadPhone.vue";
import { onMounted, onUnmounted, watch, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
const route = useRoute();
const isProductView = ref(false);
const store = useStore();
const handleResize = () => {
  if (window.innerWidth > 1200) {
    document.documentElement.style.fontSize = "16px";
    store.commit("changePcOrPhone", true);
  } else {
    document.documentElement.style.fontSize = "8px";
    store.commit("changePcOrPhone", false);
  }
};
// route
watch(route, () => {
  isProductView.value = route.name == "productItem";
});

const toIntegrated = () => {
  window.open("https://beian.miit.gov.cn/#/Integrated/index");
};

onMounted(() => {
  store.commit("changePcOrPhone", window.innerWidth > 1200);
  window.addEventListener("resize", handleResize);
  handleResize();
  document.title = "中国船道，以船入道";
  let descriptionMeta = document.createElement("meta");
  descriptionMeta.name = "description";
  descriptionMeta.content =
    "PowerFun系列划船机又称数字赛艇测功仪，将国产的划船机数据精度提高了至少100倍。目前系列包括PF-550商用版、PF-580专业版、PF-650龙舟。";
  document.head.appendChild(descriptionMeta);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  font-size: 16px;
  /* 滚动条整体样式 */
  ::-webkit-scrollbar {
    width: 1.25rem;
    height: 0.5rem;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 0.75rem;
    border: 0.375rem solid rgba(0, 0, 0, 0);
    box-shadow: 0.5rem 0 0 #a5adb7 inset;
  }

  ::-webkit-scrollbar-thumb:hover {
    box-shadow: 0.5rem 0 0 #4a4a4a inset;
  }
}

#App {
  width: 100%;
  height: 100%;
  background-color: #5b5b5b;
  &.isProductView {
    background: linear-gradient(to bottom, #ccc, #f6f6f6);
  }
}

.main {
  height: calc(100vh - 5.25rem);
  // background-color: #5b5b5b;
  // &.isProductView{
  //   background-color: #ece0e0;
  // }
  overflow: auto;
}

.footer {
  width: 100%;
  height: 5.375rem;
  background-color: #666;
  &.isProductView {
    background-color: #eee;
    color: #252525;
  }
  font-family: SourceHanSansCN-Regular;
  font-size: 1rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 5.375rem;
  font-weight: 400;
  position: relative;

  span {
    cursor: pointer;
    &:hover {
      color: #ff000d;
    }
    font-size: 1rem;
  }
}
</style>
